module.exports = __webpack_public_path__ + "assets/img/AIF-Social-Static-Ad.6c2dbf41.png";